import { atom } from 'nanostores';

/**
 * Stores the active project ID when starting a chat from a project context.
 * Cleared after the first chat save so only the initial save links the chat.
 */
export const $activeProjectId = atom<string | undefined>(undefined);

/** Display name of the active project (for the home page pill). */
export const $activeProjectName = atom<string | undefined>(undefined);
